import React from "react";

const ApprovalWorkFlow = ({
  onClickFn = () => {},
  width = "24",
  height = "24",
  fillColor = "currentColor",
  strokeColor = "currentColor",
  className = "cursor-pointer",
  ...props
}) => {
  return (
    <svg
      className={className}
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
       <path d="M6.5 2.5C6.5 1.67188 7.17188 1 8 1H10C10.8281 1 11.5 1.67188 11.5 2.5V4.5C11.5 5.32812 10.8281 6 10 6H9.75V7.25H14.5C15.4656 7.25 16.25 8.03438 16.25 9V10H16.5C17.3281 10 18 10.6719 18 11.5V13.5C18 14.3281 17.3281 15 16.5 15H14.5C13.6719 15 13 14.3281 13 13.5V11.5C13 10.6719 13.6719 10 14.5 10H14.75V9C14.75 8.8625 14.6375 8.75 14.5 8.75H9.75V10H10C10.8281 10 11.5 10.6719 11.5 11.5V13.5C11.5 14.3281 10.8281 15 10 15H8C7.17188 15 6.5 14.3281 6.5 13.5V11.5C6.5 10.6719 7.17188 10 8 10H8.25V8.75H3.5C3.3625 8.75 3.25 8.8625 3.25 9V10H3.5C4.32812 10 5 10.6719 5 11.5V13.5C5 14.3281 4.32812 15 3.5 15H1.5C0.671875 15 0 14.3281 0 13.5V11.5C0 10.6719 0.671875 10 1.5 10H1.75V9C1.75 8.03438 2.53437 7.25 3.5 7.25H8.25V6H8C7.17188 6 6.5 5.32812 6.5 4.5V2.5Z" fill={"none"} stroke="#fff"/>
    </svg>
  );
};

export default ApprovalWorkFlow;
